export default __webpack_public_path__ + "static/media/paper-plane.da767eaf.svg";